import { render, staticRenderFns } from "./upos-logo-min.vue?vue&type=template&id=4f9dc92a&"
import script from "./upos-logo-min.vue?vue&type=script&lang=ts&"
export * from "./upos-logo-min.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports